/*
 * Public API Surface of shared
 */
export * from './lib/shared.module';
export * from './lib/interfaces';
export * from './lib/directives';
export * from './lib/services';
export * from './lib/enums';
export * from './lib/store/store';
export * from './lib/functions';
export { ModalVerArchivoComponent } from './lib/components/modal-ver-archivo/modal-ver-archivo.component';